import { render, staticRenderFns } from "./commonInquiry.vue?vue&type=template&id=b7eda12c&scoped=true"
import script from "./commonInquiry.vue?vue&type=script&lang=js"
export * from "./commonInquiry.vue?vue&type=script&lang=js"
import style0 from "./commonInquiry.vue?vue&type=style&index=0&id=b7eda12c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7eda12c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7eda12c')) {
      api.createRecord('b7eda12c', component.options)
    } else {
      api.reload('b7eda12c', component.options)
    }
    module.hot.accept("./commonInquiry.vue?vue&type=template&id=b7eda12c&scoped=true", function () {
      api.rerender('b7eda12c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inquiry/commonInquiry.vue"
export default component.exports